<template>
  <div class="Productcenter">
    <div class="pagestitle clearfix">
      <span class="pageslink">
          <li><router-link class="indexicon" to="/" /></li>
          <li><router-link to="/overview">关于我们</router-link> > </li><li><router-link class='cur' :to="cur">{{curName}}</router-link></li>
      </span>
      <h4>
        <span>{{curName}}</span>
        <img class="titleimg" :src="baseApi + 'webimages/' +curImage+ '.png'" >
      </h4>
    </div>
    <div class="insidesnav clearfix">
      <router-link :class="cur === '/overview' ? 'cur': ''" to="/overview">公司概况</router-link>
      <router-link :class="cur === '/friends' ? 'cur': ''" to="/friends">合作伙伴</router-link>
      <router-link :class="cur === '/job' ? 'cur': ''" to="/job">招贤纳士</router-link>
      <router-link :class="cur === '/contact' ? 'cur': ''" to="/contact">联系我们</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cur: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  computed: {
    curName () {
      switch (this.cur) {
        case '/overview':
          return '公司概况'
        case '/friends':
          return '合作伙伴'
        case '/honor':
          return '资质荣誉'
        case '/job':
          return '招贤纳士'
        case '/contact':
          return '联系我们'
        default:
          return ''
      }
    },
    curImage () {
      switch (this.cur) {
        case '/overview':
          return 'image43'
        case '/friends':
          return 'hzhb'
        case '/honor':
          return 'zzry'
        case '/job':
          return 'zxns'
        case '/contact':
          return 'lxwm'
        default:
          return ''
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/us/componets/Tab.vue